import Modal from 'Common/Components/Modal';
import ButtonBase from 'components/ui/buttons/ButtonBase';
import React, { FC } from 'react';

type IProps = {
    show: boolean;
    handleClose: () => void;
    onConfirm: () => void;
    isAccept: boolean;
    isLoading?: boolean;
    returnItem?: {
        id: number;
        saleOrderItem?: {
            product?: {
                itemName?: string;
            };
        };
        quantity?: number;
        reasonStatus?: string;
    };
};

const AcceptRejectReturnModal: FC<IProps> = ({
    show,
    handleClose,
    onConfirm,
    isAccept,
    isLoading = false,
    returnItem,
}) => {
    const handleConfirm = () => {
        onConfirm();
    };

    const actionText = isAccept ? 'Accept' : 'Reject';
    const title = `${actionText} Return Confirmation`;
    const message = isAccept
        ? `Are you sure you want to accept this return?`
        : `Are you sure you want to reject this return?`;

    return (
        <Modal
            show={show}
            onHide={handleClose}
            dialogClassName="w-full bg-white p-3 shadow rounded-md overflow-scroll md:w-[100%] md:max-w-[500px]"
            backdropClassName="backdrop-overlay fixed inset-0 z-[1051] bg-slate-900/70 dark:bg-zink-900/85"
        >
            <Modal.Header>
                <Modal.Title className="text-lg font-semibold">{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="my-5">
                <section className="flex flex-col gap-5">
                    <p className="text-gray-700">{message}</p>
                    {returnItem && (
                        <div className="bg-gray-50 p-3 rounded-md">
                            <p className="text-sm text-gray-600">
                                <strong>Return ID:</strong> {returnItem.id}
                            </p>
                            {returnItem.saleOrderItem?.product?.itemName && (
                                <p className="text-sm text-gray-600">
                                    <strong>Product:</strong> {returnItem.saleOrderItem.product.itemName}
                                </p>
                            )}
                            {returnItem.quantity && (
                                <p className="text-sm text-gray-600">
                                    <strong>Quantity:</strong> {returnItem.quantity}
                                </p>
                            )}
                            {returnItem.reasonStatus && (
                                <p className="text-sm text-gray-600">
                                    <strong>Reason:</strong> {returnItem.reasonStatus}
                                </p>
                            )}
                        </div>
                    )}
                </section>
            </Modal.Body>
            <Modal.Footer className="flex items-center justify-center gap-2 mt-5">
                <ButtonBase
                    innerText="Cancel"
                    className="bg-gray-500 hover:bg-gray-600 rounded border-none px-4 py-2 text-white"
                    onClick={handleClose}
                    disabled={isLoading}
                />
                <ButtonBase
                    innerText={actionText}
                    className={`${
                        isAccept ? 'bg-green-600 hover:bg-green-800' : 'bg-red-600 hover:bg-red-800'
                    } rounded border-none px-4 py-2 text-white disabled:opacity-50 disabled:cursor-not-allowed`}
                    onClick={handleConfirm}
                    disabled={isLoading}
                />
            </Modal.Footer>
        </Modal>
    );
};

export default AcceptRejectReturnModal;
